'use client';
import { isBrazilianPhone } from '@payments-checkout/shared/helpers/constants/country-code.const';
import { analiticaInstance } from '@payments-checkout/shared/plugins/analitica/analitica.events';
import { InputField, InputFieldProps, MaskedInput } from '@stone-payments/jade';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { CustomerFields } from '../../types/customerInformation.types';

export function PhoneInput({
  selectedCountryCode,
  disabled = false,
}: { selectedCountryCode: string; disabled: boolean } & Omit<
  InputFieldProps,
  'label'
>) {
  const intl = useIntl();
  const {
    register,
    formState: { errors },
  } = useFormContext<CustomerFields>();

  const trackPhoneFilled = (event: { target: { value: string } }) => {
    if (event.target.value) {
      analiticaInstance.events.homePage.formFieldFilled('campo_telefone');
    }
  };

  return (
    <div>
      {isBrazilianPhone(selectedCountryCode) ? (
        <MaskedInput
          label={intl.formatMessage({ id: 'customerForm.phoneNumber' }) + ' *'}
          mask="phoneNumber"
          placeholder="(00) 00000-0000"
          size="medium"
          type="tel"
          inputMode="numeric"
          error={!!errors.phone?.message}
          disabled={disabled}
          supportText={
            errors.phone?.message &&
            intl.formatMessage({
              id: `customerForm.validate.${errors.phone?.message}`,
            })
          }
          {...register('phone', { onBlur: trackPhoneFilled })}
        />
      ) : (
        <InputField
          label={intl.formatMessage({ id: 'customerForm.phoneNumber' }) + ' *'}
          size="medium"
          placeholder="(00) 00000-0000"
          type="tel"
          inputMode="numeric"
          error={!!errors.phone?.message}
          disabled={disabled}
          supportText={
            errors.phone?.message &&
            intl.formatMessage({
              id: `customerForm.validate.${errors.phone?.message}`,
            })
          }
          {...register('phone', { onBlur: trackPhoneFilled })}
        />
      )}
    </div>
  );
}
